import React from 'react';
import { FormikProps } from 'formik';
import { Box } from '@withjoy/joykit';
import { Tabs as SharedTabs } from '@shared/components/Tabs';
import { useTranslation } from '@shared/core';
import { Contacts, newMember as guestNewMember, ContactInputFields } from '@apps/contactCollector/guest/ContactCollectorGuest.controller';
import {
  Contacts as IframeContacts,
  contactInitialValue as iFrameNewMember,
  ContactInputFields as IframeContactInputFields,
} from '@apps/contactCollector/iframe/ContactCollectorIframe.controller';

interface TabsProps
  extends Readonly<{
    formik: FormikProps<Contacts> | FormikProps<IframeContacts>;
    push: (obj: ContactInputFields | IframeContactInputFields) => void;
    isIframeVersion: boolean;
  }> {}

export const Tabs: React.FC<TabsProps> = ({ formik, push, isIframeVersion }) => {
  const { tq } = useTranslation('contactCollector');
  const newMember = isIframeVersion ? iFrameNewMember : guestNewMember;

  return (
    <Box marginTop="2rem">
      <SharedTabs
        tabTextProps={{
          typographyVariant: 'body1',
        }}
        items={[
          {
            label: 'individual',
            isActive: formik.values.contacts.length === 1,
            value: tq`Individual`,
            onClick: () => {
              const array = formik.values.contacts;
              const arrayLength = array.length;

              if (arrayLength > 1) {
                array.splice(1);
                formik.setValues({
                  contacts: array,
                } as Contacts);
              }
            },
          },
          {
            label: 'couple',
            isActive: formik.values.contacts.length === 2,
            value: tq`Couple`,
            onClick: () => {
              const array = formik.values.contacts;
              const arrayLength = array.length;

              if (arrayLength === 1) {
                push(newMember);
              }

              if (arrayLength > 2) {
                array.splice(2);
                formik.setValues({
                  contacts: array,
                } as Contacts);
              }
            },
          },
          {
            label: 'family',
            isActive: formik.values.contacts.length > 2,
            value: tq`Family`,
            onClick: () => {
              const arrayLength = formik.values.contacts.length;

              if (arrayLength === 1) {
                push(newMember);
                push(newMember);
              }

              if (arrayLength === 2) {
                push(newMember);
              }
            },
          },
        ]}
      />
    </Box>
  );
};
